import React, { useState, useEffect, useContext } from "react";
import RepositoriesScreen from "./Projects.screen";
import { ProjectsContext } from "../../contexts/ProjectsContext";

export default function ProjectsContainer() {
  const [loading, setLoading] = useState(true);
  const { projects, getUserProjects } = useContext(ProjectsContext);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    getUserProjects()
      .finally(() => {
        setLoading(false);
      })
  }

  return (
    <RepositoriesScreen
      loading={loading}
      projects={projects || []}
      reload={fetchProjects}
    />
  );
}
